export const config = {
  API_URL: process.env.REACT_APP_API_URL!,
  IS_DEVELOPMENT: process.env.NODE_ENV === 'development',
  PROJECT: (process.env.REACT_APP_PROJECT as 'finance' | 'global') ?? 'finance',
};

export const isGlobalProject = () => config.PROJECT === 'global';
export const isFinanceProject = () => config.PROJECT === 'finance';
